/**
 * PropertyStatusChip — 요약 섹션 전용 상태 배지 (목업 `.chip.status`).
 *
 * 순수 프레젠테이션. 데스크톱 패널·모바일 바텀시트·상세페이지 타이틀 블록이 공유한다.
 *
 * 정책 (대표 결정 2026-09-21 — 상태 배지는 '분양예정'만):
 *   - status=분양예정 또는 isPreRegistration 이면 "분양예정" 노출 (maskPropertyStatus 와 동일 기준)
 *   - 그 외 상태(분양중·입주예정·마감임박·분양완료 등)는 배지를 렌더하지 않는다
 *     (v2b 2026-09-21: 상세 214 제목 위 '입주예정' 노출 회귀 수정)
 */

import React from 'react';
import { maskPropertyStatus } from '../../../domain/property/formatters';

export interface PropertyStatusChipProps {
  status?: string | null;
  isPreRegistration?: boolean;
  /** 즉시입주 잔여세대(2026-09-28) — '분양예정'보다 우선 */
  isReopen?: boolean;
}

export function PropertyStatusChip({ status, isPreRegistration, isReopen }: PropertyStatusChipProps) {
  const label = maskPropertyStatus(status, !!isPreRegistration, !!isReopen);
  if (!label) return null;

  return (
    <span className="inline-flex items-center rounded-ca-sm bg-accent-50 px-2 py-1 text-[11px] font-bold text-accent">
      {label}
    </span>
  );
}

export default PropertyStatusChip;
